export const SEARCH_MANUAL_ACTIVATION = "SEARCH_MANUAL_ACTIVATION";
export const SEARCH_MANUAL_ACTIVATION_SUCCESS = "SEARCH_MANUAL_ACTIVATION_SUCCESS";
export const SEARCH_MANUAL_ACTIVATION_FAILED = "SEARCH_MANUAL_ACTIVATION_FAILED";
export const RESET_MANUAL_ACTIVATION_REPORT = "RESET_MANUAL_ACTIVATION_REPORT";
